import React from 'react';
import { Input } from './Input';
import { Select } from './Select';
import { MALAYSIAN_STATE_OPTIONS } from '../../constants/malaysia';
export interface AddressValue {
  line1: string;
  line2: string;
  postalCode: string;
  city: string;
  state: string;
}
interface AddressBlockProps {
  value: AddressValue;
  onChange: (next: AddressValue) => void;
  disabled?: boolean;
  required?: boolean;
  /** Optional namespace used to autoFocus first field. */
  autoFocusFirst?: boolean;
}
export const EMPTY_ADDRESS: AddressValue = {
  line1: '',
  line2: '',
  postalCode: '',
  city: '',
  state: ''
};
/**
 * Standardized Maybank address block.
 * Universal fields: Address Line 1, Address Line 2 (Optional),
 * Postal Code, City, State (Malaysian states only).
 */
export function AddressBlock({
  value,
  onChange,
  disabled,
  required,
  autoFocusFirst
}: AddressBlockProps) {
  const update = (field: keyof AddressValue, v: string) => onChange({
    ...value,
    [field]: v
  });
  return <div className="space-y-4" data-id="element-939">
      <Input label="Address Line 1" placeholder="e.g. No. 12, Jalan Tun Razak" value={value.line1} onChange={e => update('line1', e.target.value)} disabled={disabled} required={required} autoFocus={autoFocusFirst} data-id="element-940" />
      <Input label="Address Line 2 (Optional)" placeholder="e.g. Menara Maybank, Level 12" value={value.line2} onChange={e => update('line2', e.target.value)} disabled={disabled} data-id="element-941" />
      <div className="grid grid-cols-2 gap-4" data-id="element-942">
        <Input label="Postal Code" placeholder="e.g. 50050" value={value.postalCode} onChange={e => update('postalCode', e.target.value.replace(/\D/g, '').slice(0, 5))} disabled={disabled} required={required} maxLength={5} data-id="element-943" />
        <Input label="City" placeholder="e.g. Kuala Lumpur" value={value.city} onChange={e => update('city', e.target.value)} disabled={disabled} required={required} data-id="element-944" />
      </div>
      <Select label="State" placeholder="Select a state" options={MALAYSIAN_STATE_OPTIONS} value={value.state} onChange={e => update('state', e.target.value)} disabled={disabled} required={required} data-id="element-945" />
    </div>;
}
export const isAddressValid = (a: AddressValue) => a.line1.trim().length > 0 && a.postalCode.trim().length === 5 && a.city.trim().length > 0 && a.state.trim().length > 0;